<template>
    <div class="datatable">
        <table>
            <thead>
            <tr>
                <th>Firstname</th>
                <th>Lastname</th>
                <th>Is admin</th>
                <th>Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in users" :key="user._id">
                <td>{{ user.firstName }}</td>
                <td>{{ user.lastName }}</td>
                <td>{{ user.role }}</td>
                <td>
                    <div class="actions">
                        <router-link :to="{name: 'admin_users_new', query: {id: user._id}}" class="green-btn"><font-awesome-icon icon="pen"></font-awesome-icon></router-link>
                        <button v-if="user._id" @click="deleteUser(user._id)" class="green-btn"><font-awesome-icon icon="times"></font-awesome-icon></button>
                    </div>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "AdminUser",
        created() {
            this.getUsers()
        },
        methods: {
            ...mapActions('user', ['getUsers']),
        },
        computed:{
            ...mapGetters('user', [
                'users'
            ])
        }
    }
</script>

<style scoped>

</style>
